import { withErrorCode } from '@/lib/errors'
import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { getProductById } from '../services/shop.service'
import type { ShopProductDocument } from '../types'

export function useProduct(id: string | undefined) {
  const [product, setProduct] = useState<ShopProductDocument | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!id) {
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    getProductById(id)
      .then((p) => {
        if (!p) setError(withErrorCode('Product not found.', 'app/validation'))
        else setProduct(p)
      })
      .catch((err) => setError(formatUserFacingError(err, 'Failed to load product.')))
      .finally(() => setLoading(false))
  }, [id])

  return { product, loading, error }
}
